import React, {Component} from 'react'

import CurrentIssue from './CurrentIssue'
import Issue from './Issue'

export default class Archive extends Component {

    render() {
        return (
            <div>
                <CurrentIssue createIssue={this.props.http.createIssue} refreshDashboard={this.props.refreshDashboard}/>
                { this.props.issues.map((issue) => <Issue key={issue.number} number={issue.number} date={issue.date}/>) }
            </div>
        )
    }

}

Archive.propTypes = {
    http: React.PropTypes.object.isRequired,
    refreshDashboard: React.PropTypes.func.isRequired,
    issues: React.PropTypes.array
};



// WEBPACK FOOTER //
// ./src/dashboard/archive/Archive.js